import { ObjectValues } from "@/src/shared/types/objectValues";
import { DS_SIZE, type DSSize } from "@/src/design_system/shared/types/size";

export const DS_ICON_SIZES = {
  ExtraSmall: DS_SIZE.ExtraSmall,
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
  ExtraLarge: DS_SIZE.ExtraLarge,
} as const;

export const DS_ICON_APPEARANCES = {
  Filled: "filled",
  Outlined: "outlined",
} as const;

export type DSIconSize = DSSize;
export type DSIconAppearance = ObjectValues<typeof DS_ICON_APPEARANCES>;
